import { LocationOnRounded, PhotoCameraRounded } from '@mui/icons-material'
import { quoteAuthorName, replySnippet } from '../../utils/chatMedia'
import { stripItalicUnderscores } from '../../utils'

const KIND_ICONS = {
  image: PhotoCameraRounded,
  location: LocationOnRounded
}

export default function QuotedMessage({ replyTo, users, owner }) {
  const { kind, label, thumbnail } = replySnippet(replyTo)
  const Icon = KIND_ICONS[kind]

  return (
    <div
      data-testid='quoted-message'
      className={`flex items-stretch gap-2 rounded-lg overflow-hidden max-w-[280px] ${
        owner ? 'bg-black/20 text-white' : 'bg-light_gray dark:bg-dk-raised text-black dark:text-gray-100'
      }`}
    >
      <div className={`w-1 shrink-0 ${owner ? 'bg-white' : 'bg-light_coral'}`} />
      <div className='flex flex-col min-w-0 flex-1 py-1 pr-2'>
        <p className={`text-xs font-bold truncate ${owner ? 'text-white' : 'text-primary'}`}>
          {quoteAuthorName(replyTo?.user_id, users)}
        </p>
        <p className='text-xs flex items-center gap-1 min-w-0'>
          {Icon && <Icon sx={{ fontSize: 14 }} />}
          <span className='truncate'>{stripItalicUnderscores(label)}</span>
        </p>
      </div>
      {thumbnail && (
        <img src={thumbnail} alt='' draggable={false} className='w-10 h-10 object-cover shrink-0' />
      )}
    </div>
  )
}
